import script from "./UploadingToIpfs.vue?vue&type=script&setup=true&lang=ts"
export * from "./UploadingToIpfs.vue?vue&type=script&setup=true&lang=ts"

import "./UploadingToIpfs.vue?vue&type=style&index=0&id=61cc42e9&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61cc42e9"]])

export default __exports__